export default __webpack_public_path__ + "static/media/coupon.7cfde925.svg";